import React, { Fragment, useState } from 'react';
import Navbar from '../layouts/Navbar';
import Footer from '../layouts/Footer';
import { Alert, Button } from '@mui/material';
import HomeImage from '../assets/Home image.png'
import { useFormik } from 'formik';
import { contactSchema } from '../schemas';
import axios from 'axios';
import { useSelector } from 'react-redux';

const ContactUs = ()=>{
    const uri = useSelector(state=>state.uri)
    const [response, setResponse] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    const {handleBlur, handleChange, handleSubmit, handleReset, errors, touched, values} = useFormik({
        initialValues: {
            name: '',
            email: '',
            message: ''
        },
        validationSchema: contactSchema,
        onSubmit: (values)=>{
            setResponse('')
            setIsLoading(true)
            axios.post(
                `${uri}messages`,
                values
            ).then(res=>{
                handleReset()
                setIsLoading(false)
                setResponse(res.data.message)
            }).catch(err=>{
                setResponse('An error has occured')
                setIsLoading(false)
            })
        }
    })
    return (
        <Fragment>
            <Navbar />
            <div className='d-flex justify-content-center mt-5'>
                <div className='col-md-6 pt-5'>
                    <p className='text-yrh text-center fw-bold fs-4 my-0'>Contact Us</p>
                    <hr className='my-0 text-line' />
                </div>
            </div>
            <div className='container'>
                <div className='row w-100 my-md-5 rounded-3 mx-auto mb-4'>
                    <form className='col-md-7 pt-md-4' data-aos='fade-in'>
                        {
                            response !== ''
                            ? 
                            <Alert severity={response.includes('delivered') ? 'success' : 'error'}>
                                {response}
                            </Alert>
                            :
                            ''
                        }
                        <div className='my-4'>
                            <input className='form-control' onChange={handleChange} onBlur={handleBlur} placeholder='Name' name='name' value={values.name} />
                            {errors.name && touched.name && <div className='text-danger'>{errors.name}</div>}
                        </div>
                        <div className='my-4'>
                            <input className='form-control' onChange={handleChange} onBlur={handleBlur} placeholder='Email Address' name='email' value={values.email} />
                            {errors.email && touched.email && <div className='text-danger'>{errors.email}</div>}
                        </div>
                        <div className='my-4'>
                            <textarea rows={5} className='form-control' onChange={handleChange} onBlur={handleBlur} placeholder='Message' name='message' value={values.message} />
                            {errors.message && touched.message && <div className='text-danger'>{errors.message}</div>}
                        </div>
                        <Button onClick={handleSubmit} className={isLoading ? 'border border-yrh text-yrh font-poppins fw-bold w-100 py-2' : 'bg-yrh text-white font-poppins fw-bold w-100 py-2'}>
                            {
                                isLoading
                                ?
                                'Submiting...'
                                :
                                'Submit'
                            }
                        </Button>
                    </form>
                    <div className='col-md-5 my-md-0 my-4'>
                        <img src={HomeImage} className='img-fluid mt-md-5 mt-xl-0' data-aos='zoom-in' />
                    </div>
                </div>
            </div>
            <Footer />
        </Fragment>
    )
}

export default ContactUs